import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import MaterialTable from 'material-table';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useAlert } from 'react-alert';
import * as XLSX from 'xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { upperCase } from 'lodash';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'SUPPLIERBANKDETAILSREPORT';

export default function SupplierBankDetailsReport(props) {
  const [title, setTitle] = useState('Supplier Bank Details Report');
  const classes = useStyles();
  const [balancePaymentListDetail, setBalancePaymentListDetail] = useState({
    groupID: 0,
    factoryID: 0,
    year: '',
    month: '',
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [routes, setRoutes] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [balancePaymentListData, setBalancePaymentListData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    factoryName: '0',
    groupName: '0',
    year: '',
    monthName: ''
  });
  const alert = useAlert();
  const [alertCount, setAlertCount] = useState({
    count: 0
  });
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const componentRef = useRef();

  let date = new Date(selectedDate);
  let selectedNewMonth = date.toLocaleString('default', { month: 'long' });
  let selectedNewYear = date.getFullYear();

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    setAlertCount({
      count: 1
    });
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
    setAlertCount({
      count: alertCount.count + 1
    });
  }, [balancePaymentListDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [balancePaymentListDetail.factoryID]);

  useEffect(() => {
    clearData();
  }, [
    balancePaymentListDetail.groupID,
    balancePaymentListDetail.factoryID,
    balancePaymentListDetail.month,
    balancePaymentListDetail.year
  ]);

  function clearData() {
    setBalancePaymentListData([]);
  }

  useEffect(() => {
    const currentDate = new Date();
    const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
    setSelectedDate(previousMonth);
  }, []);

  useEffect(() => {
    if (balancePaymentListDetail.factoryID > 0 && balancePaymentListDetail.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [balancePaymentListDetail.factoryID, balancePaymentListDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWSUPPLIERBANKDETAILSREPORT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setBalancePaymentListDetail({
      ...balancePaymentListDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setBalancePaymentListDetail({
      ...balancePaymentListDetail,
      [e.target.name]: value
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      balancePaymentListDetail.groupID
    );
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      balancePaymentListDetail.factoryID
    );
    setRoutes(routeList);
  }

  async function BalancePaymentListReportDetails() {

    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();

    let requestModel = {
      groupID: parseInt(balancePaymentListDetail.groupID.toString()),
      factoryID: parseInt(balancePaymentListDetail.factoryID.toString()),
      year: applicableYear,
      month: applicableMonth
    }

    getSelectedDropdownValuesForReport(requestModel);
    const balancePaymentListData = await services.GetAllBalancePaymentList(requestModel);

    if (balancePaymentListData.statusCode == "Success" && balancePaymentListData.data != null) {
      if (balancePaymentListData.data.length == 0) {
        alert.error("No records to display");
        return;
      }
      const filteredData = balancePaymentListData.data.filter(item => item.amount !== 0);
      if (filteredData.length === 0) {
        setBalancePaymentListData([]);
        return;
      }

      setBalancePaymentListData(filteredData);
    }
    else {
      alert.error("No records to display");
    }
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(balancePaymentListDetail.groupID, balancePaymentListDetail.factoryID);
    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;

    const selectedDate = new Date(applicableYear, applicableMonth);

    setSelectedDate(selectedDate);
    setSelectedDatePDF(response);
  };

  async function createDataForExcel(array) {
    var result = [];
    var totalAmountSum = 0;

    if (array != null) {
      array.forEach(item => {
        const row = {
          registrationNumber: item.registrationNumber,
          accountHolderName: item.accountHolderName,
          accountNumber: item.accountNumber,
          amount: item.amount
        };
        totalAmountSum += item.amount;
        result.push(row);
      });
      result.push({});
      result.push({ registrationNumber: "Group: " + selectedSearchValues.groupName, accountHolderName: "Factory: " + selectedSearchValues.factoryName });
      result.push({ registrationNumber: "Month: " + selectedNewMonth + " " + selectedNewYear });
    }
    return result;
  }

  async function createFile() {
    var file = await createDataForExcel(balancePaymentListData);
    const ws = XLSX.utils.json_to_sheet(file);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Supplier Bank Details");
    XLSX.writeFile(wb, `SUPPLIER BANK DETAILS REPORT - ${selectedSearchValues.groupName} - ${selectedSearchValues.factoryName} FOR MONTH ${upperCase(selectedNewMonth)} ${selectedNewYear}.xlsx`);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleDateChange(date) {
    let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOMBER", "NOVEMBER", "DECEMBER"];
    var month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];

    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    });
    setBalancePaymentListDetail({
      ...balancePaymentListDetail,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
    setBalancePaymentListData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      groupName: GroupList[searchForm.groupID],
      routeName: routes[searchForm.routeID],
      month: searchForm.month,
      year: searchForm.year
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: balancePaymentListDetail.groupID,
              factoryID: balancePaymentListDetail.factoryID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group required')
                .min('1', 'Group required'),
              factoryID: Yup.number()
                .required('Factory required')
                .min('1', 'Factory required')
            })}
            onSubmit={() => trackPromise(BalancePaymentListReportDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={balancePaymentListDetail.groupID}
                            variant="outlined"
                            id="groupID"
                            disabled={!permissionList.isGroupFilterEnabled}
                            size="small"
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(
                              touched.factoryID && errors.factoryID
                            )}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={balancePaymentListDetail.factoryID}
                            variant="outlined"
                            id="factoryID"
                            disabled={!permissionList.isFactoryFilterEnabled}
                            size="small"
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(FactoryList)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk
                              variant="inline"
                              openTo="month"
                              views={["year", "month"]}
                              label="Month *"
                              helperText="Select applicable month"
                              value={selectedDate}
                              disableFuture={true}
                              onChange={date => handleDateChange(date)}
                              size="small"
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row-reverse" p={2} >
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                        >
                          Search
                        </Button>
                      </Box>
                    </CardContent>
                    <PerfectScrollbar>
                      <Box minWidth={1050}>
                        {balancePaymentListData.length > 0 ? (
                          <MaterialTable
                            size="small"
                            title="Multiple Actions Preview"
                            columns={[
                              {
                                title: 'Registration Number',
                                field: 'registrationNumber',
                                cellStyle: { textAlign: 'left', border: '1px solid #ccc' }
                              },
                              {
                                title: 'Acc Holder Name',
                                field: 'accountHolderName',
                                cellStyle: { textAlign: 'left', border: '1px solid #ccc' }
                              },
                              {
                                title: 'Account Number',
                                field: 'accountNumber',
                                cellStyle: { textAlign: 'left', border: '1px solid #ccc' }
                              },
                              {
                                title: 'Amount (Rs)',
                                field: 'amount',
                                render: rowData => rowData.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                                cellStyle: { textAlign: 'right', border: '1px solid #ccc' }
                              }
                            ]}
                            data={balancePaymentListData}
                            options={{
                              exportButton: false,
                              showTitle: false,
                              headerStyle: {
                                textAlign: 'center',
                                border: '1px solid #ccc',
                                height: '1%',
                                backgroundColor: '#fff'
                              },
                              cellStyle: { textAlign: 'left', border: '1px solid #ccc' },
                              columnResizable: false,
                              actionsColumnIndex: -1,
                              pageSize: 10
                            }}
                            actions={[]}
                          />
                        ) : null}
                      </Box>
                      {balancePaymentListData.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef} balancePaymentListData={balancePaymentListData} selectedSearchValues={selectedSearchValues} selectedNewMonth={selectedNewMonth} selectedNewYear={selectedNewYear}
                            />
                          </div>
                          <div>&nbsp;</div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
